import React from "react";
import EvidencePanel from "../components/EvidencePanel";

export default function EvidenceManager() {
  return (
    <div className="p-6 space-y-4" data-testid="evidence-root">
      <div>
        <div className="section-label">Assurance</div>
        <h1 className="text-2xl font-bold tracking-tight mt-1">Evidence Document Manager</h1>
        <p className="text-sm text-ink-soft">
          Every measurement should be backed by source evidence — utility bills, vendor certificates,
          audit reports. Files are stored in a tenant-isolated, encrypted-at-rest path.
        </p>
      </div>
      <div className="card p-5">
        <EvidencePanel />
      </div>
    </div>
  );
}
